<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'AppHome',
  components: {},
}
</script>
